// 前端路由：登录 + 移动端告警列表
export default [
  {
    path: '/',
    name: 'index',
    meta: { title: '首页', auth: 1 },
    component: () => import('@/views/index.jsx'),
    children: [
      {
        path: '/:project_id/alarm',
        name: 'alarm-new',
        meta: { title: '告警', auth: 1 },
        component: () => import('@/views/alarm/index.jsx'),
        redirect: (to) => `/${to.params.project_id}/alarm/list`,
        children: [
          {
            path: '/:project_id/alarm/list',
            name: 'alarm-new-list',
            meta: { title: '告警列表', auth: 1 },
            component: () => import('@/views/alarm/list/index.jsx'),
          },
          {
            path: '/:project_id/alarm/detail/:id',
            name: 'alarm-new-detail',
            meta: { title: '告警详情', auth: 1 },
            component: () => import('@/views/alarm/detail/index.jsx'),
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    // 仅微信绑定（?bind=1），非绑定入口由守卫重定向到 /auth-fail
    meta: { title: '绑定账号', auth: 0 },
    component: () => import('@/views/login/index.jsx'),
  },
  {
    path: '/auth-fail',
    name: 'auth-fail',
    meta: { title: '无法访问', auth: 0 },
    component: () => import('@/views/auth-fail/index.jsx'),
  },

]
